import packageInfo from '../../../package.json';
import { documentationUrls } from './documentation-urls';

export const environment = {
  environment: 'development',
  production: false,
  devMode: true, //disables annoying features like lockscreen while developing
  ssoAllowed: false, // only available on staging & production

  version: packageInfo?.version,

  authAppURL: 'http://localhost:4200',
  authApiURL: 'http://localhost:8080',

  portfolioClientName: 'APOLLO_PORTFOLIO',
  portfolioAppURL: 'http://localhost:4201',
  portfolioApiURL: 'http://localhost:8080/graphql',

  aiApiUrl: 'http://localhost:3000/api/ai',

  workspaceAppURL: 'http://localhost:4204',
  workspaceApiURL: 'http://localhost:8080/graphql',

  ...documentationUrls,

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept local',
  otpBannerEnabled: false,

  environmentIndicator: {
    color: 'purple',
    text: 'Lokaal',
    icon: 'exclamation-triangle',
  },

  bugsnagApikey: 'd4948bc3c3690da8470e18c6ecc91cb4',
};
